import { c as _c } from "react/compiler-runtime";
import { Chat2Icon, DocPencilIcon, PersonIcon } from "@navikt/aksel-icons";
import { BodyLong, Heading } from "@navikt/ds-react";
import { IconRow } from "@/components/icons/IconRow";
import { Skeletor } from "@/components/skeleton/Skeletor";
import { hvaBetyrDetText, hvaMaDuGjoreText, hvordanVurdererText } from "./InfoTexts";
interface Props {
  harArbeidsgiver: boolean;
  displaySkeleton?: boolean;
}
export const AktivitetskravInfo = t0 => {
  const $ = _c(65);
  const {
    harArbeidsgiver,
    displaySkeleton: t1
  } = t0;
  const displaySkeleton = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <BodyLong spacing={true}>Hei!</BodyLong>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== displaySkeleton) {
    t3 = <Skeletor displaySkeleton={displaySkeleton}>{t2}</Skeletor>;
    $[1] = displaySkeleton;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <BodyLong>Det er på tide å informere deg om aktivitetsplikten. Alle sykmeldte skal i utgangspunktet jobbe litt hvis de kan, også hvis de er 100 % sykmeldt. Dette kalles aktivitetsplikt i folketrygdloven.</BodyLong>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== displaySkeleton) {
    t5 = <Skeletor displaySkeleton={displaySkeleton}>{t4}</Skeletor>;
    $[4] = displaySkeleton;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t5) {
    t6 = <div>{t3}{t5}</div>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <DocPencilIcon />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Heading size="medium" level="2" spacing={true}>Hvordan vurderer NAV aktivitetsplikten?</Heading>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== displaySkeleton) {
    t9 = <Skeletor displaySkeleton={displaySkeleton}>{t8}</Skeletor>;
    $[11] = displaySkeleton;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== harArbeidsgiver) {
    t10 = hvordanVurdererText(harArbeidsgiver);
    $[13] = harArbeidsgiver;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10) {
    t11 = <BodyLong>{t10}</BodyLong>;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== displaySkeleton || $[18] !== t11) {
    t12 = <Skeletor displaySkeleton={displaySkeleton}>{t11}</Skeletor>;
    $[17] = displaySkeleton;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t9) {
    t13 = <div>{t9}{t12}</div>;
    $[20] = t12;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== displaySkeleton || $[24] !== t13) {
    t14 = <IconRow icon={t7} displaySkeleton={displaySkeleton}>{t13}</IconRow>;
    $[23] = displaySkeleton;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <PersonIcon />;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Heading size="medium" level="2" spacing={true}>Hva betyr det for deg?</Heading>;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== displaySkeleton) {
    t17 = <Skeletor displaySkeleton={displaySkeleton}>{t16}</Skeletor>;
    $[28] = displaySkeleton;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== harArbeidsgiver) {
    t18 = hvaBetyrDetText(harArbeidsgiver);
    $[30] = harArbeidsgiver;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t18) {
    t19 = <BodyLong>{t18}</BodyLong>;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== displaySkeleton || $[35] !== t19) {
    t20 = <Skeletor displaySkeleton={displaySkeleton}>{t19}</Skeletor>;
    $[34] = displaySkeleton;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t17 || $[38] !== t20) {
    t21 = <div>{t17}{t20}</div>;
    $[37] = t17;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== displaySkeleton || $[41] !== t21) {
    t22 = <IconRow icon={t15} displaySkeleton={displaySkeleton}>{t21}</IconRow>;
    $[40] = displaySkeleton;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Chat2Icon />;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Heading size="medium" level="2" spacing={true}>Hva må du gjøre?</Heading>;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== displaySkeleton) {
    t25 = <Skeletor displaySkeleton={displaySkeleton}>{t24}</Skeletor>;
    $[45] = displaySkeleton;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== harArbeidsgiver) {
    t26 = hvaMaDuGjoreText(harArbeidsgiver);
    $[47] = harArbeidsgiver;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== t26) {
    t27 = <BodyLong>{t26}</BodyLong>;
    $[49] = t26;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== displaySkeleton || $[52] !== t27) {
    t28 = <Skeletor displaySkeleton={displaySkeleton}>{t27}</Skeletor>;
    $[51] = displaySkeleton;
    $[52] = t27;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] !== t25 || $[55] !== t28) {
    t29 = <div>{t25}{t28}</div>;
    $[54] = t25;
    $[55] = t28;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  let t30;
  if ($[57] !== displaySkeleton || $[58] !== t29) {
    t30 = <IconRow icon={t23} displaySkeleton={displaySkeleton}>{t29}</IconRow>;
    $[57] = displaySkeleton;
    $[58] = t29;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] !== t14 || $[61] !== t22 || $[62] !== t30 || $[63] !== t6) {
    t31 = <div className="flex flex-col gap-8">{t6}{t14}{t22}{t30}</div>;
    $[60] = t14;
    $[61] = t22;
    $[62] = t30;
    $[63] = t6;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  return t31;
};